import { UPDATE, UPDATE_SUCCEEDED, UPDATE_FAILED } from "../types"

export const update = config => {
  return { type: UPDATE, config }
}

export const updateSuccess = (action, response) => {
  return {
    type: UPDATE_SUCCEEDED,
    action,
    response,
    config: action.config,
  }
}

export const updateError = (action, error) => {
  return { type: UPDATE_FAILED, action, error }
}
